module.exports = __webpack_public_path__ + "img/zip.79681455.svg";